import React from 'react';
import MovieCard from './MovieCard';
import TheBrief from './TheBrief';
import AdSlot from './AdSlot';

const SearchResults = ({ searchResults, isLoading, error, onMovieClick, currentQuery, onPlayTrailer }) => {
  // The thinking state lives in HomePage now (editorial skeletons). While the
  // request is in flight we render nothing here.
  if (isLoading) return null;

  if (error) {
    return (
      <div className="text-center py-16">
        <p className="font-serif italic text-lg text-binge-sub mb-2">The index didn’t answer.</p>
        <p className="text-sm text-binge-faint">{error}</p>
      </div>
    );
  }

  if (!searchResults) return null;

  if (searchResults.results.length === 0) {
    return (
      <div className="text-center py-16">
        <p className="font-serif italic text-lg text-binge-sub">
          Nothing survives those filters — loosen one and the curator will try again.
        </p>
        <p className="text-sm text-binge-faint mt-2">No matches for “{currentQuery}”.</p>
      </div>
    );
  }

  const took = ((searchResults.search_time_ms || 900) / 1000).toFixed(1);

  return (
    <div className="animate-fadein">
      {/* The editorial AI section: brief, curator note, shortlist, write-back */}
      <TheBrief
        query={currentQuery}
        results={searchResults.results}
        kind="movie"
        onItemClick={onMovieClick}
        took={took}
      />

      {/* Shared grid */}
      <div className="flex items-baseline justify-between pt-11 pb-5 gap-4 flex-wrap">
        <span className="text-[11px] tracking-[0.2em] uppercase text-binge-faint">
          All {searchResults.total_results} matches · ranked by fit
        </span>
        <span className="font-serif italic text-sm text-binge-faint hidden sm:block">
          every result scored against your words, not just keywords
        </span>
      </div>

      <AdSlot id="results-top" format="leaderboard" />

      <div
        className="grid gap-x-6 gap-y-8"
        style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(168px, 1fr))' }}
      >
        {searchResults.results.map((movie, index) => (
          <React.Fragment key={movie.id}>
            <div className="animate-rise" style={{ animationDelay: `${Math.min(index * 0.045, 0.7)}s` }}>
              <MovieCard movie={movie} onClick={onMovieClick} showSimilarityScore={true} onPlayTrailer={onPlayTrailer} />
            </div>
            {index === 9 && (
              <div className="col-span-full">
                <AdSlot id="results-ingrid" format="in-grid" />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default SearchResults;
